module.exports = __webpack_public_path__ + "img/UT0380.471a5c94.png";